import { LoaderFunction } from "react-router-dom";
import { questionsApi } from "src/api/services/questionsApi";
import { store } from "src/api/store";
import { ROWS_PER_PAGE } from "src/constants/rowPerPage";
import { PAGE, LIMIT } from "src/constants/searchParams";

export const questionsLoader: LoaderFunction = ({ request }) => {
  const searchParams = new URL(request.url).searchParams;
  const page =
    searchParams.get(PAGE) != null ? Number(searchParams.get(PAGE)) : 0;
  const limit =
    searchParams.get(LIMIT) != null
      ? Number(searchParams.get(LIMIT))
      : ROWS_PER_PAGE[0];

  return store
    .dispatch(
      questionsApi.endpoints.getQuestions.initiate({
        from: page * limit,
        to: page * limit + limit - 1,
      }),
    )
    .unwrap();
};
